import cx from "classnames";

import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type TerraformModuleSlugPrefixProps = {
  terraformProvider: string | undefined;
  hasError: boolean;
};

const TerraformModuleSlugPrefix = ({
  terraformProvider,
  hasError,
}: TerraformModuleSlugPrefixProps) => {
  const prefixText = `terraform-${terraformProvider || "default"}-`;

  return (
    <Box
      className={cx(styles.namePrefix, hasError && styles.namePrefixError)}
      align="center"
      shrink="1"
      grow="0"
      zeroMinWidth
    >
      <TextEllipsis tooltip={prefixText}>
        {({ className, ...triggerProps }) => (
          <Typography
            {...triggerProps}
            tag="span"
            variant="p-body3"
            color="secondary"
            className={cx(styles.namePrefixTypography, className)}
          >
            {prefixText}
          </Typography>
        )}
      </TextEllipsis>
    </Box>
  );
};

TerraformModuleSlugPrefix.displayName = "TerraformModuleSlugPrefix";

export default TerraformModuleSlugPrefix;
